export default{
    setPageTitle:(state,title)=>{
        state.pageTitle = title
    },
    setPreRouter:(state,router)=>{
        state.preRouter = router
    },
    setPreType:(state,type)=>{
        state.pageFooterType = type
    },
    setCity:(state,city)=>{
        state.city = city
    },
    setProfessionalTypeList:(state,professionalTypeList)=>{
        state.professionalTypeList =professionalTypeList
    }
}